import React, { useEffect, useContext, useState } from "react";
//img
import profileImg from "../../../assets/images/png/Profile.png";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
//css
import classes from "./slab.module.css";
//components
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import { Box, Fade, Modal, Tooltip, Zoom } from "@mui/material";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
// import DCheckboxInput from "../../../components/Dashboard/DashboardInputs/DCheckboxInput";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
//API
import { useSelector } from "react-redux";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import {
  emptyCheck,
  validateFile,
  validateNumber,
} from "../../../utils/validations";
import { AddCircleOutline, Close, DeleteOutline, MoreHoriz } from "@mui/icons-material";
//custom hooks
import DFileUpload from "../../../components/Dashboard/DashboardInputs/DFileUpload";
import DefaultLabel from "../../../components/Dashboard/DefaultLabel/DefaultLabel";
//smaple xl/ csv file for download
import sampleCSV from "../../../assets/files/Sample Items CSV.xlsx";
import { saveAs } from "file-saver";
import unspscCodes from "../../../data/unspsc.json";
import hsnCodes from "../../../data/hsn.json";
import { getUniqueData } from "../../../utils/getUniqueData";
import { downloadFile } from "../../../utils/downloadFile";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import set from "date-fns/fp/set/index";
import { CurrencyContext } from "../../../context/CurrencyContext";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import { formatInrAmount } from "../../../utils/currencyFormat";
import PaginationComponent from "../../../components/common/Pagination/PaginationComponent";
import { previouPageClick, nextPageClick } from "../../../utils/pagination";

const PAGE_SIZE = 10;
const STAGE_NAME_MAX_LENGTH = 30;

const getListRecords = (payload) => {
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.response)) return payload.response;
  if (Array.isArray(payload?.records)) return payload.records;
  return [];
};

const getListPagination = (payload, fallbackLength = 0) => {
  const currentPageCount = Number(
    payload?.current_page_count ?? payload?.page_size ?? PAGE_SIZE,
  );
  const totalCount = Number(
    payload?.total_count ?? payload?.count ?? fallbackLength,
  );
  const pageCount = Number(
    payload?.page_count ??
      payload?.total_pages ??
      (currentPageCount > 0 ? Math.ceil(totalCount / currentPageCount) : 0),
  );

  return {
    total_count: Number.isFinite(totalCount) ? totalCount : fallbackLength,
    current_page_count: Number.isFinite(currentPageCount)
      ? currentPageCount
      : fallbackLength,
    page_count: Number.isFinite(pageCount) ? pageCount : 0,
  };
};

const getSlabUserId = (user) => {
  if (user && typeof user === "object") return user.id || user.token || "";
  return "";
};

const getSlabUserLabel = (user) => {
  if (user && typeof user === "object") {
    const fullName = [user.org__first_name, user.org__last_name]
      .filter(Boolean)
      .join(" ")
      .trim();
    return String(
      user.full_text || user.name || user.approver_name || fullName || "",
    ).trim();
  }
  return String(user || "").trim();
};

const getSlabUserEmail = (user) => {
  if (user && typeof user === "object") {
    return String(user.email || user.org__email || user.user_email || "").trim();
  }
  return "";
};

const getSlabUserDisplayName = (user) => {
  const label = getSlabUserLabel(user);
  if (!label) return getSlabUserEmail(user) || "-";
  return label
    .split(" - ")
    .map((part) => part.trim())
    .filter(Boolean)[0] || label;
};

const getSlabUserDisplayText = (user) => {
  const name = getSlabUserDisplayName(user);
  const email = getSlabUserEmail(user);
  if (!email || name === email) return name;
  return `${name} - ${email}`;
};

const SlabConfig = () => {
  //get data from use selector
  const data = useSelector((state) => state.loginData.value);
  // const itemsData = '';

  //popuptext
  const [popupHeroText, setPopupHeroText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");

  //search filtered data
  const [searchQuery, setSearchQuery] = useState("");

  const [sortingColumnName, setSortingColumnName] = useState(null);
  const [sortingOrder, setSortingOrder] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [paginationData, setPaginationData] = useState({
    total_count: 0,
    current_page_count: 0,
    page_count: 0,
  });
  //unique user
  const [uniqueData, setUniqueData] = useState();
  const [uniqueDataID, setUniqueDataID] = useState("");

  //credentials
  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [user_token, setUserToken] = useState(data?.user?.user_token);
  const [org_token, setOrgToken] = useState(data?.user?.token);

  //get org users
  const [users, setUsers] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [userError, setUserError] = useState(false);
  const [orgName, setOrgName] = useState();
  const [orgId, setOrgId] = useState();
  const [configUsers, setConfigUsers] = useState([]);

  //btn label
  const [loadingState, setLoadingState] = useState(false);
  const [loadingStateDwnload, setLoadingStateDwnload] = useState(false);

  //button label
  const [primaryBtnLabel, setPrimaryBtnLabel] = useState();

  //toggle add/update actions
  const [itemsAction, setItemsAction] = useState({
    addItem: false,
    updateItem: false,
    addBulkItem: false,
  });

  const [UNSPSCList, setUNSPSCList] = useState(
    unspscCodes?.map((e) => e.commodity + " - " + e.commodity_name)
  );
  const [HSNList, setHSNList] = useState(
    hsnCodes?.map((e) => e.hsn_code + " - " + e.description)
  );

  // error message
  const [primaryBtnError, setPrimaryBtnError] = useState({
    error: false,
    errorMsg: "",
  });
  const [tableProps, setTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });

  const [approvers, setApprovers] = useState([]);
  const approverRows = Array.isArray(approvers) ? approvers : [];
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedApprovers, setSelectedApprovers] = useState({
    value: [],
    id: [],
    isValid: true,
  });
  const [departmentError, setDepartmentError] = useState(false);

  const {
    fromCurrency,
    setFromCurrency,
    toCurrency,
    countryName,
    setToCurrency,
    firstAmount,
    setFirstAmount,
  } = useContext(CurrencyContext);

  const regexForAlphabets = /[^a-zA-Z\s]/g;
  const regexForAlphaNumeric = /[^a-zA-Z0-9\s]+/g;
  const specialAlphaNumericRegex = /^[a-zA-Z0-9\s\W]+$/;
  const regexForNumber = /[^\d\s]/g;

  const GetUserList = async () => {
    await axios({
      url: `${API_ENDPOINT.all_user_list}`,
      method: "POST",
      data: {
        buyer_token: org_token,
      },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        const allUsers = Array.isArray(res?.data) ? res.data : [];
        const normalizedUsers = allUsers
          .filter((user) => user?.token !== user_token)
          .map((user) => ({
            ...user,
            full_text: `${user?.first_name || ""} ${user?.last_name || ""} - ${user?.designation || ""}`.trim(),
          }));
        setUsers(normalizedUsers);
        setOrgName(normalizedUsers[0]?.company_name || data?.user?.company_name || "");
        setOrgId(normalizedUsers[0]?.org_id || data?.user?.org_id || data?.org_id);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const GetConfigList = async () => {
    const formData = new FormData();
    formData.append("org_id", orgId);
    formData.append("admin_token", user_token);
    formData.append("search", searchQuery);
    formData.append("page", pageNumber);
    formData.append("page_size", PAGE_SIZE);
    formData.append("sort_by", sortingColumnName || "created_at");
    formData.append("sort_order", sortingOrder || "desc");
    await axios({
      url: `${API_ENDPOINT.slab_config_list}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        const records = getListRecords(res?.data);
        setConfigUsers(records);
        setPaginationData(getListPagination(res?.data, records.length));
      })
      .catch((err) => {
        console.log("err", err);
        setConfigUsers([]);
        setPaginationData({
          total_count: 0,
          current_page_count: 0,
          page_count: 0,
        });
      });
  };
  const itemsData = configUsers.map((item) => ({
    ...item,
    department: item?.department || item?.dept_name || "",
  }));
  // const itemsData = configUsers?.map(item => ({
  //   ...item,
  //   users: item.users ? item.users.split(',').map(user => user.trim()) : [],
  // }));

  // setUniqueData({
  //   ...uniqueData,
  //   users: uniqueData.users ? uniqueData.users.split(',').map(user => user.trim()) : [],
  // });

  const handleAddApprover = () => {
    let updatedApprovers = [...approvers];
    if (updatedApprovers.length > 0) {
      updatedApprovers[updatedApprovers.length - 1].showPlus = false;
    }
    const newApprover = {
      id: approvers.length + 1,
      value: "",
      department: "",
      isValid: true,
      showPlus: true,
    };
    updatedApprovers.push(newApprover);
    setApprovers(updatedApprovers);
  };

  const handleRemoveApprover = (id = null) => {
    let updatedApprovers;

    if (id === null) {
      updatedApprovers = [];
    } else {
      updatedApprovers = approvers.filter((approver) => approver.id !== id);
    }

    if (updatedApprovers.length > 0) {
      updatedApprovers[updatedApprovers.length - 1].showPlus = true;
    }

    setApprovers(updatedApprovers);
  };

  const renderApproverFields = () => {
    return (
      approverRows.map((approver, index) => (
        <div key={approver.id} className={classes.approverFieldWrapper}>
          <div className={classes.approverFieldInput}>
            <DSelectInput
              customClass={classes.fields}
              label="Department"
              required={true}
              placeHolder="Select Department"
              value={approver.department || ""}
              options={departmentOptions}
              onChange={(department) => {
                const updatedApprovers = [...approvers];
                const selectedUser = users.find(
                  (user) => user.id === updatedApprovers[index].id,
                );
                updatedApprovers[index].department = department || "";
                if (
                  selectedUser &&
                  String(selectedUser?.department || "").trim().toLowerCase() !==
                    String(department || "").trim().toLowerCase()
                ) {
                  updatedApprovers[index].value = "";
                  updatedApprovers[index].id = "";
                  updatedApprovers[index].isValid = false;
                }
                setApprovers(updatedApprovers);
              }}
              size={"100%"}
            />
            <DSelectInput
              customClass={classes.fields}
              getIDValue={true}
              label={`Approver ${index + 2}`}
              required={true}
              placeHolder={"Select Approver"}
              value={approver.value}
              options={getFilteredApproverOptionSet(
                approver.value,
                index,
                approver.department,
              )}
              onChange={(e) => {
                const selectedToken =
                  userOptions?.values.tokens[
                    userOptions?.values?.visibleOption?.indexOf(e)
                  ];
                let updatedApprovers = [...approvers];
                updatedApprovers[index].value = e;
                updatedApprovers[index].id = selectedToken;
                updatedApprovers[index].isValid = e !== "";
                const selectedUser = users.find((user) => user.id === selectedToken);
                if (selectedUser?.department) {
                  updatedApprovers[index].department = selectedUser.department;
                }
                setApprovers(updatedApprovers);
              }}
              error={!approver.isValid}
              errorMsg={"Approver is required"}
              size={"100%"}
            />
          </div>
          <div className={classes.approverFieldButtonRow}>
            <DButton
              customClass={classes.removeActionButton}
              labelImg={<DeleteOutline />}
              iconWidth={"2rem"}
              iconHeight={"2rem"}
              btnWidth={"4.4rem"}
              btnHeight={"4.4rem"}
              tooltipMessage="Remove approver"
              loadingState={loadingState}
              error={primaryBtnError.error}
              errorMsg={primaryBtnError.errorMsg}
              onClick={() => handleRemoveApprover(approver.id)}
            />
            {approver.showPlus && (
              <DButton
                customClass={classes.addActionButton}
                labelImg={<AddCircleOutline />}
                iconWidth={"2rem"}
                iconHeight={"2rem"}
                btnWidth={"4.4rem"}
                btnHeight={"4.4rem"}
                tooltipMessage="Add approver"
                loadingState={loadingState}
                error={primaryBtnError.error}
                errorMsg={primaryBtnError.errorMsg}
                onClick={handleAddApprover}
              />
            )}
          </div>
        </div>
      ))
    );
  };

  const getInitials = (name = "") =>
    String(name)
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || "")
      .join("") || "AP";

  const getApproverLabel = (value) => {
    if (Array.isArray(value)) return value.find(Boolean) || "";
    return typeof value === "string" ? value : "";
  };

  const findApproverByLabel = (label) => {
    const normalized = String(label || "").trim();
    if (!normalized) return null;
    return users.find(
      (user) => String(user?.full_text || "").trim() === normalized,
    );
  };

  const findApproverById = (id) => {
    const normalized = String(id || "").trim();
    if (!normalized) return null;
    return users.find(
      (user) =>
        String(user?.id || "").trim() === normalized ||
        String(user?.token || "").trim() === normalized,
    );
  };

  const resolveApproverSelection = (id, label) => {
    const approverLabel = getApproverLabel(label);
    const selectedUser = findApproverByLabel(approverLabel) || findApproverById(id);
    const resolvedId = selectedUser?.id || id;
    const resolvedName =
      selectedUser?.full_text?.split(" - ")[0] ||
      approverLabel.split(" - ")[0] ||
      "";

    return {
      id: resolvedId,
      name: String(resolvedName || "").trim(),
    };
  };

  const getApproverOptionUser = (user) =>
    findApproverById(getSlabUserId(user)) ||
    findApproverByLabel(getSlabUserLabel(user));

  const getApproverOptionLabel = (user) =>
    getApproverOptionUser(user)?.full_text || getSlabUserLabel(user);

  const getApproverOptionId = (user) => {
    const optionLabel = getApproverOptionLabel(user);
    return (
      getApproverOptionUser(user)?.id ||
      getSlabUserId(user) ||
      userOptions.values.tokens[
        userOptions.values.visibleOption.indexOf(optionLabel)
      ] ||
      ""
    );
  };

  const getApproverDepartment = (user) =>
    String(
      getApproverOptionUser(user)?.department ||
        (user && typeof user === "object" ? user.department : "") ||
        "",
    ).trim();

  const getApproverNameFromSelection = (id, label) => {
    return resolveApproverSelection(id, label).name;
  };

  const getSelectedApproverPayload = () => {
    const defaultApproverID = Array.isArray(selectedApprovers.id)
      ? selectedApprovers.id.find(Boolean)
      : selectedApprovers.id;

    const additionalApprovers = approverRows
      .filter((approver) => approver?.id || getApproverLabel(approver?.value))
      .map((approver) =>
        resolveApproverSelection(approver.id, approver.value),
      );

    const approverItems = [
      defaultApproverID || getApproverLabel(selectedApprovers.value)
        ? resolveApproverSelection(defaultApproverID, selectedApprovers.value)
        : null,
      ...additionalApprovers,
    ].filter((item) => item?.id);

    return {
      ids: approverItems.map((item) => item.id),
      names: approverItems.map((item) => item.name).filter(Boolean),
    };
  };

  const activeApproverEntries = [
    (() => {
      const selectedApproverLabel = getApproverLabel(selectedApprovers?.value);
      const selectedApproverId = Array.isArray(selectedApprovers?.id)
        ? selectedApprovers.id.find(Boolean)
        : selectedApprovers?.id;
      if (!selectedApproverLabel && !selectedApproverId) return null;
      const selectedUser = users.find((user) => user.id === selectedApproverId);
      return {
        key: `primary-${selectedApproverId || selectedApproverLabel}`,
        kind: "primary",
        id: selectedApproverId,
        name:
          selectedUser?.full_text?.split(" - ")[0] ||
          selectedApproverLabel.split(" - ")[0] ||
          "Primary Approver",
        meta: `Dept: ${selectedDepartment || selectedUser?.department || "-"}${
          selectedUser?.designation ? ` - ${selectedUser.designation}` : ""
        }`,
      };
    })(),
    ...(Array.isArray(approvers)
      ? approvers
          .map((approver) => {
            const selectedUser = users.find((user) => user.id === approver.id);
            const approverLabel = getApproverLabel(approver.value);
            if (!selectedUser && !approverLabel) return null;
            return {
              key: `extra-${approver.id || approverLabel}`,
              kind: "extra",
              rowId: approver.id,
              name:
                selectedUser?.full_text?.split(" - ")[0] ||
                approverLabel.split(" - ")[0] ||
                "Additional Approver",
              meta: `Dept: ${
                approver.department || selectedUser?.department || "-"
              }${selectedUser?.designation ? ` - ${selectedUser.designation}` : ""}`,
            };
          })
          .filter(Boolean)
      : []),
  ].filter(Boolean);

  const handleRemoveActiveApprover = (entry) => {
    if (entry.kind === "primary") {
      setSelectedApprovers({ value: "", id: "", isValid: true });
      return;
    }
    handleRemoveApprover(entry.rowId);
  };

  const getFilteredOptions = (currentApprover, index, departmentOverride = "") => {
    // const defaultApproverValue = Array.isArray(selectedApprovers.value)
    //   ? selectedApprovers.value
    //   : [selectedApprovers.value];

    // const selectedApproversList = [
    //   ...defaultApproverValue,
    //   ...approvers.map((approver, i) => approver.value && i !== index ? approver.value : null)
    // ].filter(Boolean);

    const selectedApproversList = [
      selectedApprovers.value,
      ...(Array.isArray(approvers)
        ? approverRows.map((approver) => approver.value)
        : []),
    ].filter(Boolean);

    const selectedIds = [selectedApprovers.id, ...approverRows.map((item) => item.id)]
      .filter(Boolean);
    const selectedUsers = users.filter((user) => selectedIds.includes(user.id));
    const effectiveDepartment =
      departmentOverride ||
      selectedDepartment ||
      selectedUsers.find((user) => user?.department)?.department ||
      "";

    return users
      .filter(
        (user) =>
          !effectiveDepartment ||
          String(user?.department || "").trim().toLowerCase() ===
            String(effectiveDepartment).trim().toLowerCase(),
      )
      .map((user) => user.full_text)
      .filter(
        (option) =>
          !selectedApproversList.includes(option) || option === currentApprover,
      );
  };
  const userOptions = {
    values: {
      tokens: users?.map((user) => user.id) || [],
      visibleOption: users?.map((user) => user.full_text) || [],
    },
  };

  const handleApproverChange = (e) => {
    const selectedToken =
      userOptions?.values.tokens[
        userOptions?.values?.visibleOption?.indexOf(e)
      ];
    setSelectedApprovers({
      value: e,
      id: selectedToken,
      isValid: e !== "",
    });
    const selectedUser = users.find((user) => user.id === selectedToken);
    if (selectedUser?.department) setSelectedDepartment(selectedUser.department);
  };

  const getFilteredApproverOptionSet = (
    currentApprover,
    index,
    departmentOverride = "",
  ) => {
    const visibleOption = getFilteredOptions(
      currentApprover,
      index,
      departmentOverride,
    );
    return {
      visibleOption,
      tokens: visibleOption.map(
        (label) => users.find((user) => user.full_text === label)?.id || "",
      ),
    };
  };

  const departmentOptions = [
    ...new Set(users.map((user) => String(user?.department || "").trim()).filter(Boolean)),
  ];

  const visibleDepartmentOptions = (() => {
    const selectedIds = [selectedApprovers.id, ...approverRows.map((item) => item.id)]
      .filter(Boolean);
    const selectedDepartments = [
      ...new Set(
        users
          .filter((user) => selectedIds.includes(user.id))
          .map((user) => String(user?.department || "").trim())
          .filter(Boolean),
      ),
    ];
    return selectedDepartments.length ? selectedDepartments : departmentOptions;
  })();

  const handleMatrixDepartmentChange = (department) => {
    setSelectedDepartment(department || "");
    setDepartmentError(false);
    if (!department) return;
    const normalized = String(department).trim().toLowerCase();
    const defaultUser = users.find((user) => user.id === selectedApprovers.id);
    if (
      defaultUser &&
      String(defaultUser?.department || "").trim().toLowerCase() !== normalized
    ) {
      setSelectedApprovers({ value: "", id: "", isValid: true });
    }
    setApprovers((current) =>
      current.filter((approver) => {
        const user = users.find((item) => item.id === approver.id);
        return String(user?.department || "").trim().toLowerCase() === normalized;
      }),
    );
  };

  const initializeSelectedApprovers = (existingEmails) => {
    const defaultApprover = existingEmails[0] || "";
    const defaultApproverEmail = getApproverOptionLabel(defaultApprover);
    // console.log('useroptions',userOptions)
    // console.log('defaultApproverEmail',defaultApproverEmail)
    const defaultApproverId = getApproverOptionId(defaultApprover);
    // console.log('defaultApproverId',defaultApproverId)
    setSelectedApprovers({
      value: defaultApproverEmail,
      id: defaultApproverId,
      isValid: defaultApproverEmail !== "",
    });

    const dynamicApprovers = existingEmails.slice(1).map((user, index) => {
      const full_text = getApproverOptionLabel(user);
      const emailId = getApproverOptionId(user);
      return {
        id: emailId,
        value: full_text,
        department: getApproverDepartment(user),
        showPlus: index === existingEmails.length - 2,
      };
    });
    setApprovers(dynamicApprovers);
  };

  useEffect(() => {
    GetUserList();
    setPrimaryBtnLabel(
      itemsAction.addItem
        ? "Add"
        : itemsAction.updateItem
        ? "Update"
        : itemsAction.addBulkItem
        ? "Add"
        : ""
    );
  }, [itemsAction]);

  useEffect(() => {
    if (orgId) {
      GetConfigList();
    }
  }, [orgId, searchQuery, pageNumber, sortingColumnName, sortingOrder]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, buyerAdmin_approverRange_search } =
      JSON.parse(chatActionRaw);

    if (action === "search_po_approver_range") {
      if (!itemsData || itemsData.length === 0) return;

      console.log(buyerAdmin_approverRange_search?.searchText);
      setSearchQuery(buyerAdmin_approverRange_search?.searchText || "");
      setPageNumber(1);

      sessionStorage.removeItem("CHAT_ACTION");
    }

    if (action === "add_po_approver_range") {
      handleOpenAddItem();
    }
  }, [itemsData]);

  const updateInputs = (data) => {
    setStageName((prev) => ({
      ...prev,
      value: data?.name,
    }));
    const firstApproverDepartment = Array.isArray(data?.users)
      ? getApproverDepartment(data.users[0])
      : "";
    setSelectedDepartment(
      data?.department || data?.dept_name || firstApproverDepartment || "",
    );

    // setSelectedApprovers((prev) => ({
    //   ...prev,
    //   value: data?.users,
    // }));

    setStartPrice((prev) => ({
      ...prev,
      value: data?.price_start,
    }));

    SetEndPrice((prev) => ({
      ...prev,
      value: data?.price_end,
    }));

    if (data?.users?.length > 0) {
      const defaultApprover = data.users[0];
      const defaultApproverValue = getApproverOptionLabel(defaultApprover);
      const defaultApproverId = getApproverOptionId(defaultApprover);
      setSelectedApprovers((prev) => ({
        ...prev,
        value: defaultApproverValue,
        id: defaultApproverId,
        isValid: true,
      }));

      const remainingApprovers = data.users.slice(1).map((user, index) => ({
        value: getApproverOptionLabel(user),
        id: getApproverOptionId(user),
        department: getApproverDepartment(user),
        isValid: true,
        showPlus: index === data.users.length - 2,
      }));

      // if (remainingApprovers.length === 0) {
      //   remainingApprovers.push({ value: '', id: '', isValid: false, showPlus: true });
      // }

      setApprovers(remainingApprovers);
    } else {
      setSelectedApprovers((prev) => ({
        ...prev,
        value: [],
        id: [],
        isValid: false,
      }));

      // setApprovers([{ value: '', id: '', isValid: false, showPlus: true }]);
    }
    setFromCurrency((prev) => ({
      ...prev,
      currency: data?.currency_type,
      countryName: data?.country_name && data?.country_name,
    }));
  };

  //demo data for the datatable
  const headings = [
    {
      label: "Name",
      field: "name",
      col_width: "280px",
      minWidth: "280px",
      noWrap: true,
      sortable: false,
      renderCell: (row) => {
        const stageName = String(row?.name || "-");

        return (
          <Tooltip
            title={stageName}
            arrow
            placement="top"
            enterDelay={250}
            componentsProps={{
              tooltip: {
                className: classes.stageNameTooltip,
                sx: {
                  fontSize: "14px",
                  lineHeight: 1.45,
                  padding: "8px 12px",
                  maxWidth: "42rem",
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                },
              },
              arrow: {
                className: classes.stageNameTooltipArrow,
                sx: { fontSize: "18px" },
              },
            }}
          >
            <span className={classes.stageNameCell}>{stageName}</span>
          </Tooltip>
        );
      },
    },
    {
      label: "Users",
      field: "users",
      sortable: false,
      renderCell: (row) => {
        const uniqueUsers = [
          ...new Set(
            (Array.isArray(row?.users) ? row.users : [])
              .map((user) => getSlabUserDisplayText(user))
              .filter(Boolean),
          ),
        ];

        return uniqueUsers.length ? uniqueUsers.join(", ") : "-";
      },
    },
    // { label: "Department", field: "department" },
    { label: "Currency", field: "currency_type", sortable: false },
    { label: "Start Price", field: "price_start", additional_data: "currency" },
    { label: "End Price", field: "price_end", additional_data: "currency" },
    { label: "Created Date", field: "created_at", additional_data: "date" },

    // { label: "Status", field: "status", additional_data: "toggle" },
  ];

  // modal states
  const [open, setOpen] = useState(false);

  const handleOpenAddItem = () => {
    setOpen(true);
    resetForm();
    setItemsAction({
      addItem: true,
      updateItem: false,
    });
    // addCodesList(hsnCodes, setHSNList);
  };

  // const addCodesList = (listData, setData) => {
  //   setData(listData?.map(e => e.hsn_code))
  // }

  const handleOpenAddBulkItem = () => {
    setOpen(true);
    resetForm();
    setItemsAction({
      addItem: false,
      updateItem: false,
      addBulkItem: true,
    });
  };
  const handleOpenEditItem = (unique_id) => {
    setOpen(true);
    // resetForm();
    let rowData = getUniqueData(itemsData, "id", unique_id);
    const existingApproversEmails = Array.isArray(rowData?.users)
      ? rowData.users
      : [];
    initializeSelectedApprovers(existingApproversEmails);

    updateInputs({
      ...rowData,
      users: existingApproversEmails,
    });
    setUniqueDataID(unique_id);
    setItemsAction({
      addItem: false,
      updateItem: true,
    });
  };

  const handleClose = () => {
    setOpen(false);
    setPrimaryBtnError({
      error: false,
      errorMsg: "",
    });
    setApprovers([]);
    setSelectedApprovers({ value: "", id: "", isValid: true });
  };

  // S - success popup
  const [openS, setOpenS] = useState(false);
  const handleOpenS = () => {
    setOpenS(true);
  };
  const handleCloseS = () => {
    setOpenS(false);
  };

  // VU - View User popup
  const [openViewItemPopup, setOpenViewItemPopup] = useState(false);
  const handleOpenViewItemPopup = (unique_id) => {
    let rowData = getUniqueData(itemsData, "id", unique_id);
    setUniqueData(rowData);
    // setUniqueData({
    //   ...rowData,
    //   users: rowData.users ? rowData.users.split(',').map(user => user.trim()) : [],
    // });
    setOpenViewItemPopup(true);
  };
  const handleCloseViewItemPopup = () => {
    setOpenViewItemPopup(false);
  };

  // viewItemsActionButtons
  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={"OK"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleCloseViewItemPopup}
    />,
  ];
  const viewUserChildren = [
    <InfoLabel size={"44%"} label={"Stage Name"} value={uniqueData?.name} />,
    <InfoLabel
      size={"44%"}
      label={"Start price"}
      value={formatInrAmount(uniqueData?.price_start)}
    />,
    <InfoLabel
      size={"44%"}
      label={"End Price"}
      value={formatInrAmount(uniqueData?.price_end)}
    />,
    <InfoLabel
      size={"44%"}
      label={"Users"}
      value={
        uniqueData?.users ? (
          <ul className={classes.viewApproverList}>
            {uniqueData.users.map((user, index) => (
              <li key={index} className={classes.viewApproverItem}>
                {getSlabUserDisplayText(user)}
              </li>
            ))}
          </ul>
        ) : (
          "-"
        )
      }
    />,
    // <InfoLabel
    //   size={"44%"}
    //   label={"UNSPSC Code"}
    //   value={uniqueData?.unspsc_code}
    // />,
    // <InfoLabel size={"100%"} label={"HSN Code"} value={uniqueData?.hsn_code} />,
  ];

  const viewUserHeading = (
    <HeaderTitle
      titleText={uniqueData?.name || <MoreHoriz sx={{ fontSize: "30px" }} />}
      customclass={classes.VUpopupHeading}
    />
  );

  //common states for CRUD
  const [itemName, setItemName] = useState({
    value: "",
    isValid: true,
  });
  const [itemCode, setItemCode] = useState({
    value: "",
    isValid: true,
  });
  const [HSNCode, setHSNCode] = useState({
    value: "",
    isValid: true,
  });
  const [UNSPSCCode, setUNSPSCCode] = useState({
    value: "",
    isValid: true,
  });
  const [ItemCategory, setItemCategory] = useState({
    value: "",
    isValid: true,
  });
  const [csvFile, setCsvFile] = useState({
    value: "",
    isValid: true,
  });
  const [user, setUser] = useState({
    value: "",
    isValid: true,
  });

  const [startPrice, setStartPrice] = useState({
    value: "",
    isValid: true,
  });
  const [endPrice, SetEndPrice] = useState({
    value: "",
    isValid: true,
  });
  const [stageName, setStageName] = useState({
    value: "",
    isValid: true,
  });
  const [currencyType, setCurrencyType] = useState({
    value: "",
    isValid: true,
  });
  // const [vendorId, setVendorID] = useState([]);
  const [existingVendorList, setExistingVendorList] = useState([]);

  const resetForm = () => {
    setItemCode({
      value: "",
      isValid: true,
    });
    setItemCategory({
      value: "",
      isValid: true,
    });
    setItemName({
      value: "",
      isValid: true,
    });
    setHSNCode({
      value: "",
      isValid: true,
    });
    setUNSPSCCode({
      value: "",
      isValid: true,
    });
    setCsvFile({
      value: "",
      isValid: true,
    });
    setStartPrice({
      value: "",
      isValid: true,
    });
    setStageName({
      value: "",
      isValid: true,
    });
    SetEndPrice({
      value: "",
      isValid: true,
    });
    setSelectedApprovers({
      value: "",
      id: "",
      isValid: true,
    });
    setSelectedDepartment("");
  };

  const validateForm = (query) => {
    // const isItemName = emptyCheck(itemName.value);
    // const isItemCode = emptyCheck(itemCode.value);
    // const isItemCategory = emptyCheck(ItemCategory.value);
    // const isHSNCode = HSNCode.value?.trim() !== "" && HSNCode.value !== null;

    const isStageName = emptyCheck(stageName.value);
    const isStartPrice = emptyCheck(String(startPrice.value));
    const isEndPrice =
      emptyCheck(String(endPrice.value)) &&
      parseFloat(endPrice.value) > parseFloat(startPrice.value);
    const areUsersSelected =
      selectedApprovers.value && selectedApprovers.value.length > 0;
    const validatedApprovers = approverRows.map((approver) => ({
      ...approver,
      isValid: Boolean(getApproverLabel(approver?.value)),
    }));
    const areAdditionalApproversSelected = validatedApprovers.every(
      (approver) => approver.isValid,
    );
    const isDepartmentSelected = Boolean(String(selectedDepartment || "").trim());

    const isCsvFile = validateFile(
      csvFile.value,
      false,
      ["csv", "xlsx"],
      5
    ).isValid;

    setStartPrice((prev) => ({
      ...prev,
      isValid: isStartPrice,
    }));
    SetEndPrice((prev) => ({
      ...prev,
      isValid: isEndPrice,
    }));
    setStageName((prev) => ({
      ...prev,
      isValid: isStageName,
    }));
    setSelectedApprovers((prev) => ({
      ...prev,
      isValid: areUsersSelected,
    }));
    setApprovers(validatedApprovers);
    setUserError(!areUsersSelected);
    setDepartmentError(!isDepartmentSelected);

    // setUser((prev) => ({
    //   ...prev,
    //   isValid: isUser,
    // }));

    if (query === "bulkData") {
      setCsvFile((prev) => ({
        ...prev,
        isValid: isCsvFile,
      }));

      /* return isCsvFile; */
    } else {
      return (
        isStartPrice &&
        isEndPrice &&
        areUsersSelected &&
        areAdditionalApproversSelected &&
        isStageName &&
        isDepartmentSelected
      );
    }
  };

  // ADD Item function
  const addItem = async () => {
    const approverPayload = getSelectedApproverPayload();

    const formData = new FormData();
    formData.append("id", "");
    formData.append("org_id", orgId);
    formData.append("admin_token", user_token);
    formData.append("name", stageName.value);
    formData.append("price_start", startPrice.value);
    formData.append("price_end", endPrice.value);
    // formData.append("users", selectedApprovers.id);
    formData.append("currency", fromCurrency.currency);
    formData.append("country_name", fromCurrency.countryName);
    formData.append("users", approverPayload.ids);
    formData.append("approver_name", approverPayload.names.join(", "));
    formData.append("approver_names", JSON.stringify(approverPayload.names));
    formData.append("department", selectedDepartment);
    formData.append("dept_name", selectedDepartment);

    await axios({
      url: `${API_ENDPOINT.slab_config}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // GetAllData();
        setPopupHeroText("Slab Added!");
        setPopupMessage(res?.data?.response);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
        setSelectedApprovers({ value: "", id: "", isValid: true });
        setApprovers([]);
        GetConfigList();
      })
      .catch((err) => {
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
        setLoadingState(false);
      });
  };

  // ADD Bulk Items function
  const addBulkItems = async () => {
    const formData = new FormData();

    formData.append("org_token", org_token);
    formData.append("csv_file", csvFile.value);

    await axios({
      url: `${API_ENDPOINT.add_bulk_items}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        GetConfigList();
        setPopupHeroText("Items Added!");
        setPopupMessage(res?.data?.response);
        handleOpenS();
        handleClose();
        resetForm();
        setLoadingState(false);
      })
      .catch((err) => {
        setPrimaryBtnError({
          error: true,
          errorMsg:
            (typeof err?.response?.data?.response !== "object" &&
              err?.response?.data?.response) ||
            "Something went wrong! please check the file values & try again.",
        });
        setLoadingState(false);
      });
  };

  // Update item submit click
  const updateItem = async () => {
    // console.log('approvers', approvers)
    // console.log('selectedApprovers', selectedApprovers)
    const approverPayload = getSelectedApproverPayload();
    const formData = new FormData();
    formData.append("id", uniqueDataID);
    formData.append("org_id", orgId);
    formData.append("admin_token", user_token);
    formData.append("name", stageName.value);
    formData.append("price_start", startPrice.value);
    formData.append("price_end", endPrice.value);
    formData.append("users", approverPayload.ids);
    formData.append("approver_name", approverPayload.names.join(", "));
    formData.append("approver_names", JSON.stringify(approverPayload.names));
    formData.append("currency", fromCurrency.currency);
    formData.append("country_name", fromCurrency.countryName);
    formData.append("department", selectedDepartment);
    formData.append("dept_name", selectedDepartment);

    await axios({
      url: `${API_ENDPOINT.slab_config}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        GetConfigList();
        setPopupHeroText("Slab Updated!");
        setPopupMessage(res?.data?.response);
        handleClose();
        handleOpenS();
        resetForm();
        setLoadingState(false);
        GetConfigList();
        setApprovers([]);
      })
      .catch((err) => {
        console.log(err);
        setPrimaryBtnError({
          error: true,
          errorMsg: Object.values(err?.response?.data)[0],
        });
        setLoadingState(false);
      });
  };

  //submit click ADD/UPDATE item
  const handleSubmit = () => {
    const validation = itemsAction.addBulkItem
      ? validateForm("bulkData")
      : validateForm();
    if (validation) {
      if (itemsAction.addItem) {
        setLoadingState(true);
        addItem();
      } else if (itemsAction.updateItem) {
        setLoadingState(true);
        updateItem();
      } else if (itemsAction.addBulkItem) {
        setLoadingState(true);
        addBulkItems();
      }
    } else {
      setItemName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setItemCode((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setItemCategory((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setHSNCode((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setUNSPSCCode((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setCsvFile((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setStartPrice((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setStageName((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      SetEndPrice((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
      setUser((prevState) => ({
        ...prevState,
        isValid: prevState.isValid,
      }));
    }
  };

  //category select options
  const selectCategory = ["Select", "IT", "Stationary"];

  // INPUTS
  const InputsHeading = (
    <div className={classes.slabModalHeader}>
      <HeaderTitle
        titleText={
          itemsAction.addItem
            ? "Add Slab Range"
            : itemsAction.updateItem
            ? "Update Approver Range"
            : itemsAction.addBulkItem
            ? "Add Bulk Items"
            : ""
        }
        customclass={classes.popupHeading}
      />
      <button type="button" className={classes.slabCloseButton} onClick={handleClose}>
        <Close sx={{ fontSize: 18 }} />
      </button>
    </div>
  );

  const ItemInputs = [
    <div key="slab-details-section" className={classes.slabSection}>
      <div className={classes.slabSectionHeader}>
        <p className={classes.slabSectionTitle}>Slab Details</p>
      </div>
      <div className={classes.slabFieldRow}>
        <DTextInput
          label="Stage Name"
          required={true}
          type="text"
          maxLength={STAGE_NAME_MAX_LENGTH}
          value={stageName.value}
          onChange={(e) => {
            let val = e.target.value.slice(0, STAGE_NAME_MAX_LENGTH);
            setStageName({
              value: val,
              isValid: emptyCheck(val),
            });
          }}
          error={!stageName.isValid}
          customClassName={classes.popupFields}
          errorMsg={"Stage Name is required"}
          size={"100%"}
        />
        <SelectCountry
          customClass={classes.approvercountry}
          style={{ padding: "10px" }}
          value={fromCurrency}
          setValue={setFromCurrency}
          label={
            <>
              Currency <span className={classes.requiredMark}>*</span>
            </>
          }
          width={"100%"}
          onChange={(newCurrency) => {
            setFromCurrency({
              ...newCurrency,
            });
          }}
        />
        <DTextInput
          label="Start Price"
          required={true}
          type="number"
          maxLength={250}
          value={startPrice.value}
          onChange={(e) => {
            let val = e.target.value;
            setStartPrice({
              value: val,
              isValid: emptyCheck(e.target.value),
            });
          }}
          error={!startPrice.isValid}
          customClassName={classes.popupFields}
          errorMsg={"Start Price required"}
          size={"100%"}
        />
        <DTextInput
          label="End Price"
          required={true}
          type="number"
          value={endPrice.value}
          onChange={(e) => {
            let val = e.target.value;
            SetEndPrice({
              value: val,
              isValid: emptyCheck(e.target.value),
            });
          }}
          error={!endPrice.isValid}
          customClassName={classes.popupFields}
          errorMsg={
            endPrice.value != "" && endPrice.value <= startPrice.value
              ? "End Price should be higher than Start Price"
              : "End Price required"
          }
          size={"100%"}
        />
      </div>
    </div>,
    <div key="slab-approver-section" className={classes.slabSection}>
      <div className={classes.slabSectionHeader}>
        <p className={classes.slabSectionTitle}>Approver Configuration</p>
      </div>
      <div className={classes.approverConfigCard}>
        <div className={classes.slabFieldRow}>
          <DSelectInput
            customClass={classes.fields}
            label="Department"
            required={true}
            value={selectedDepartment}
            placeHolder="Select Department"
            options={visibleDepartmentOptions}
            onChange={handleMatrixDepartmentChange}
            error={departmentError}
            errorMsg={"Department is required"}
            size={"100%"}
          />
          <DSelectInput
            customClass={classes.fields}
            getIDValue={true}
            label="Approver"
            required={true}
            value={selectedApprovers.value}
            placeHolder={"Select Approver"}
            options={getFilteredApproverOptionSet(selectedApprovers.value, -1)}
            onChange={handleApproverChange}
            error={!selectedApprovers.isValid}
            errorMsg={"Approver is required"}
            size={"100%"}
          />
        </div>
        <div key="po-add-approver-action" className={classes.approverActionRow}>
          <DButton
            labelImg={<AddCircleOutline />}
            iconWidth={"2rem"}
            iconHeight={"2rem"}
            btnWidth={"4.4rem"}
            btnHeight={"4.4rem"}
            customClass={classes.addApproverIconButton}
            tooltipMessage="Add approver"
            loadingState={loadingState}
            error={primaryBtnError.error}
            errorMsg={primaryBtnError.errorMsg}
            onClick={handleAddApprover}
          />
        </div>
        {approvers.length > 0 && (
          <div className={classes.additionalApproversSection}>
            {renderApproverFields()}
          </div>
        )}
      </div>
    </div>,
    <div key="active-approvers-section" className={classes.activeApproversSection}>
      <div className={classes.slabSectionHeader}>
        <p className={classes.activeApproverEyebrow}>
          Active Approvers ({activeApproverEntries.length})
        </p>
      </div>
      <div className={classes.activeApproverList}>
        {activeApproverEntries.length > 0 ? (
          activeApproverEntries.map((entry, index) => (
            <div key={entry.key} className={classes.activeApproverItem}>
              <div
                className={`${classes.activeApproverAvatar} ${
                  index % 2 === 0 ? classes.activeApproverAvatarPrimary : classes.activeApproverAvatarAccent
                }`}
              >
                {getInitials(entry.name)}
              </div>
              <div className={classes.activeApproverContent}>
                <p className={classes.activeApproverName}>{entry.name}</p>
                <p className={classes.activeApproverMeta}>{entry.meta}</p>
              </div>
              <button
                type="button"
                className={classes.activeApproverRemove}
                onClick={() => handleRemoveActiveApprover(entry)}
              >
                <Close sx={{ fontSize: 16 }} />
              </button>
            </div>
          ))
        ) : (
          <div className={classes.activeApproverEmpty}>
            No approvers added yet. Configure one above to begin the approval chain.
          </div>
        )}
      </div>
    </div>,
  ];

  const BulkItemInputs = [
    <div className={classes.input_container}>
      <DefaultLabel label={"Uploadfile"} />
      <DFileUpload
        fileTypes={".xlsx,.csv"}
        customFileTypeText={"(Supported format CSV, XLSX)"}
        onFileUpload={(file) => {
          let isFileValid = validateFile(
            file,
            false,
            ["csv", "xlsx"],
            5
          ).isValid;
          setCsvFile({
            value: file,
            isValid: isFileValid,
          });
        }}
        error={!csvFile.isValid}
        errorMsg={
          validateFile(csvFile.value, false, ["csv", "xlsx"], 5, "CSV file")
            .errorMessage
        }
        size={"100%"}
      />
      <p
        className={classes.linkBtn}
        onClick={() => {
          saveAs(sampleCSV, "Sample CSV");
        }}
      >
        Sample CSV
      </p>
    </div>,
  ];

  const itemsActionsButton = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleClose}
      btnWidth={"16rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={itemsAction.updateItem ? "Update Slab Range" : "Add Slab Range"}
      btnWidth={"16rem"}
      btnHeight={"4rem"}
      loadingState={loadingState}
      error={primaryBtnError.error}
      errorMsg={primaryBtnError.errorMsg}
      onClick={handleSubmit}
    />,
  ];

  //deletion popups and functions
  const deleteItem = async (deletionType) => {
    let isHardDelete = deletionType && deletionType === "hard delete";
    setLoadingState(true);

    setPopupMessage("");

    if (isHardDelete) {
      const formData = new FormData();
      formData.append("id", uniqueDataID);
      formData.append("status", "3");
      formData.append("org_id", orgId);
      formData.append("admin_token", user_token);
      formData.append("name", stageName.value);
      formData.append("price_start", startPrice.value);
      formData.append("price_end", endPrice.value);
      formData.append("users", selectedApprovers.value);
      formData.append("currency", "");
      formData.append("country_name", "");

      await axios({
        method: "POST",
        url: `${API_ENDPOINT.slab_config}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then((res) => {
          GetConfigList();
          handleCloseDltConfirmation();
          setPopupHeroText(`Slab Deleted Successfully!`);
          setPopupMessage(res?.data?.response);
          setLoadingState(false);
          GetConfigList();
        })
        .catch((err) => {
          setPopupHeroText("OOPS! Something went wrong");
          setPopupMessage(err?.response?.data?.response);
          console.log(err);
          setLoadingState(false);
        });
    } else {
      await axios({
        method: "POST",
        url: `${API_ENDPOINT.delete_item}`,
        data: {
          token: uniqueDataID,
          status: itemStatus,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then((res) => {
          GetConfigList();
          handleCloseDltConfirmation();
          setPopupHeroText(
            `Item ${itemStatus ? "Activated!" : "Deactivated!"}`
          );
          setPopupMessage(res?.data?.response);
          setLoadingState(false);
        })
        .catch((err) => {
          setPopupHeroText("Something went wrong!");
          setPopupMessage(err?.response?.data?.response);
          console.log(err);
          setLoadingState(false);
        });
    }
  };

  //delete data
  const [openDlt, setOpenDlt] = useState(false);
  const handleOpenDlt = () => setOpenDlt(true);
  const handleCloseDlt = () => {
    setOpenDlt(false);
  };
  const [openDltConfirmation, setOpenDltConfirmation] = useState(false);
  const [itemStatus, setItemStatus] = useState();

  const [itemHardDelete, setItemHardDelete] = useState(false);

  const handleOpenDltConfirmation = (deletion_id, rowData, deletionType) => {
    let isHardDelete = deletionType && deletionType === "hard delete";
    setItemHardDelete(isHardDelete);
    let popupMsg = rowData.status
      ? "Are you sure want to deactivate"
      : "Are you sure want to activate";
    let status = !rowData.status;
    let uniqueData = getUniqueData(itemsData, "id", deletion_id);
    setPopupHeroText(
      `${isHardDelete ? "Are you sure want to delete" : popupMsg} "${
        uniqueData?.name
      }"?`
    );
    setOpenDltConfirmation(true);
    setUniqueDataID(deletion_id);
    setItemStatus(status);
  };
  const handleCloseDltConfirmation = () => {
    setOpenDltConfirmation(false);
    setItemHardDelete(false);
  };
  const handleDeleteUser = () => {
    handleOpenDlt();
    itemHardDelete ? deleteItem("hard delete") : deleteItem();
    handleCloseDltConfirmation();
  };

  return (
    <div className={classes.users_tab_wrapper}>
      <div className={classes.users_topHeader}>
        <div className={`${classes.lhs} ${classes.flex}`}>
          <HeaderTitle
            titleText="Value-Based Purchase Order Approval"
            customclass={classes.dashHead}
          />
        </div>

        {/* <div className={`${classes.notificationBar}`}>
          <DateBar />
          <NotificationBell />
          <ProfileCard
            imageSrc={profileImg}
            profilePath={"/Organization_dashboard/My_profile"}
          />
        </div> */}
      </div>

      <div className={classes.search_add_wrapper}>
        <SearchBar
          value={searchQuery}
          onChange={(query) => {
            setSearchQuery(query);
            setPageNumber(1);
          }}
          placeholder="Search by Name, Users, Price..."
        />

        <div
          className={classes.flex}
          style={{
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          {/* <DropdownBtnOutlined
            label="DOWNLOAD AS"
            btnHeight="4rem"
            btnWidth="18rem"
            loadingState={loadingStateDwnload}
            disabled={itemsData?.length === 0}
            onClick={(fileFormat) => {
              downloadFile({
                key: "org_token",
                value: org_token,
                fileNameProp: "Items Data",
                outputFormat: fileFormat,
                API_ENDPOINT: API_ENDPOINT.csv_org_item_view,
                authToken: auth_token,
                setLoadingState: setLoadingStateDwnload,
              });
            }}
            options={["CSV", "PDF"]}
          /> */}

          {/* <DButtonOutlined
            iconWidth="1rem"
            iconHeight="1rem"
            label="UPLOAD"
            btnHeight="4rem"
            onClick={handleOpenAddBulkItem}
          /> */}

          <DButton
            labelImg={plusIcon}
            iconWidth="1rem"
            iconHeight="1rem"
            label="PO APPROVAL MATRIX"
            btnHeight="4rem"
            onClick={handleOpenAddItem}
          />
        </div>
      </div>

      <div className={`${classes.d_dataTable}`}>
        <DataTable
          headings={headings}
          tableData={itemsData}
          actions={true}
          stickyHead={true}
          stickyFirstColumn={true}
          stickyFirstColumnOffset={0}
          tableSize={itemsData?.length === 0 ? "100%" : "100%"}
          viewBtn={true}
          deleteBtn={true}
          editBtn={true}
          sorting={true}
          viewClick={handleOpenViewItemPopup}
          editClick={handleOpenEditItem}
          toggleOnChange={handleOpenDltConfirmation}
          deleteClick={(id, row) => {
            handleOpenDltConfirmation(id, row, "hard delete");
          }}
          errorMessage={tableProps.errorMessage}
          isLoading={tableProps.isLoading}
          itemsTable={true}
          setSortingColumnName={setSortingColumnName}
          sortingColumnName={sortingColumnName}
          setSortingOrder={setSortingOrder}
          sortingOrder={sortingOrder}
          viewTooltip={"View"}
          actionColumnWidth="12rem"
        />
        <PaginationComponent
          pageNumber={pageNumber}
          currentPage={pageNumber}
          itemsPerPage={paginationData?.current_page_count || 0}
          totalItems={paginationData?.page_count || 0}
          setPageNumber={setPageNumber}
          previouPageClick={() => previouPageClick(pageNumber, setPageNumber)}
          nextPageClick={() =>
            nextPageClick(pageNumber, setPageNumber, paginationData)
          }
          disablePrevious={Number(pageNumber) <= 1}
          disableNext={
            Number(pageNumber) >= Number(paginationData?.page_count || 0)
          }
        />
      </div>

      {/* modal popups */}

      {/* add/update item modal */}
      <Modal
        open={open}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Fade in={open}>
          <div
            className={classes.flex}
            style={{
              minHeight: "100vh",
            }}
          >
            <PopupFrame
              inputChildren={
                itemsAction.addItem
                  ? ItemInputs
                  : itemsAction.updateItem
                  ? ItemInputs
                  : itemsAction.addBulkItem
                  ? BulkItemInputs
                  : ItemInputs
              }
              poupHeading={InputsHeading}
              actionButtons={itemsActionsButton}
              actionButtonsClass={classes.slabFooterActions}
              closePopup={handleClose}
              customClass={`${itemsAction.updateItem ? classes.updatePopup : classes.addPopup} ${classes.slabModalCard}`}
              styleCenterDiv={classes.slabModalBody}
            />
          </div>
        </Fade>
      </Modal>

      {/* view user modal */}
      <Modal
        open={openViewItemPopup}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openViewItemPopup}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
              overflow: "auto",
            }}
          >
            <PopupFrame
              inputChildren={viewUserChildren}
              poupHeading={viewUserHeading}
              actionButtons={viewItemsActionButtons}
              closePopup={handleCloseViewItemPopup}
              width={"auto"}
              customClass={classes.addPopup}
              styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      {/* success modal */}
      <Modal
        open={openS}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Fade in={openS}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseS}
            />
          </Box>
        </Fade>
      </Modal>

      {/* delete error modal two states - confirmation and deletion */}

      {/* confirmation */}
      <Modal open={openDltConfirmation}>
        <Fade in={openDltConfirmation}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popBtn={true}
              btnText={"Yes"}
              secondaryBtn={true}
              btnTextSecondary={"No"}
              btnClick={handleDeleteUser}
              customHeroTextClass={classes.popupTxtSm}
              btnClickSecondary={handleCloseDltConfirmation}
            />
          </Box>
        </Fade>
      </Modal>

      {/* deletion */}
      <Modal open={openDlt}>
        <Fade in={openDlt}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Okay"}
              loadingPrimaryBtn={loadingState}
              btnClick={handleCloseDlt}
              customHeroTextClass={classes.popupTxtSm}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default SlabConfig;
